/* Created by Interactive 63 - https://interactive63.com */
/**
 * A start-up feature check: whether this browser's `getScreenCTM()` includes the CSS zoom on an
 * ancestor. The stage relies on it to place handles and rulers on screen; if a browser leaves it
 * out, the stage applies the zoom itself.
 */

const SVG_NS = 'http://www.w3.org/2000/svg';

/** Renders a 10 px square at zoom 2 and compares its screen matrix with its real size. */
export function screenCtmIncludesZoom(): boolean {
  const host = document.createElement('div');
  host.style.cssText =
    'position:fixed;left:0;top:0;width:0;height:0;transform:scale(2);transform-origin:0 0;visibility:hidden;pointer-events:none';
  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttribute('width', '10');
  svg.setAttribute('height', '10');
  const rect = document.createElementNS(SVG_NS, 'rect');
  rect.setAttribute('width', '10');
  rect.setAttribute('height', '10');
  svg.append(rect);
  host.append(svg);
  document.body.append(host);
  try {
    const matrix = rect.getScreenCTM();
    const drawn = rect.getBoundingClientRect().width;
    return !matrix || drawn === 0 || Math.abs(matrix.a * 10 - drawn) < 0.5;
  } finally {
    host.remove();
  }
}
